import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    Show,
    ShowButton,
    TabbedShowLayout, Tab,
    Resource, ReferenceField, Filter, TextInput, ReferenceInput, SelectInput,
    useRecordContext, Edit
} from 'react-admin';
import ShowActions from './showActions';
import ShowActionsAbholgebietTermineExport from "./showActionsAbholgebietTermineExport";
import {makeStyles} from "@mui/styles";
import {Paper, Typography} from "@mui/material";

const AbholgebietFilter = (props) => (
    <Filter {...props}>
        <ReferenceInput label="Landkreis" source="landkreis" reference="landkreise" sort={'ASC'} perPage={20} alwaysOn allowEmpty>
            <SelectInput optionText="name" optionValue="id"/>
        </ReferenceInput>
        <TextInput label="Name" source="name" alwaysOn/>
        <TextInput label="Beschreibung" source="beschreibung" alwaysOn/>
    </Filter>
);

const AbholgebietList = props => {
    const record = useRecordContext();
    return (
        <List title={"Abholgebiete"}
              filters={<AbholgebietFilter/>}
              exporter={false}
              {...props}>
            <Datagrid rowClick="edit">
                <TextField source="name"/>
                <TextField source="kurzname"/>
                <TextField source="beschreibung"/>
                <TextField source="landkreis.name" label={"Landkreis"}/>
                <TextField source="anmerkung"/>
                <ShowButton label={"Details"}/>
            </Datagrid>
        </List>
    );
}

const AbholgebietOrtsteilList = props => {
    const record = useRecordContext();
    return (
        <List {...props} title={"Ortsteile"} reference="abholgebiet-ortsteile" filterDefaultValues={{ abholgebiet: record.id }} target="abholgebiet_id">
            <Datagrid>
                <ReferenceField source={"ortsteil"} reference={"gemeindeteile"}>
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source={"ortsteil"} reference={"gemeindeteile"} label={"Gemeinde"} >
                    <ReferenceField source={"gemeinde"} reference={"gemeinden"}>
                        <TextField source="name"/>
                    </ReferenceField>
                </ReferenceField>
            </Datagrid>
        </List>
    );
}

const AbholgebietMengeList = props => {
    const record = useRecordContext();
    return (
        <List {...props} title={"Mengen"} reference="abholgebiet-mengen" filterDefaultValues={{ abholgebiet: record.id }} target="abholgebiet_id">
            <Datagrid>
                <ReferenceField source={"abfallart"} reference={"abfallarten"}>
                    <TextField source="name" />
                </ReferenceField>
                <TextField source="mengeMax"/>
            </Datagrid>
        </List>
    );
}

const AbholgebietShow = (props) => {
    return (
        <Show title={"Abholgebiet"} actions={<ShowActions/>} {...props}>
            <TabbedShowLayout>
                <Tab label="Abholgebiet">
                    <TextField source="id"/>
                    <TextField source="name"/>
                    <TextField source="kurzname"/>
                    <TextField source="beschreibung"/>
                    <TextField source="landkreis.name" label={"Landkreis"}/>
                </Tab>
                <Tab label="Ortsteile">
                    <Resource name="abholgebiet-ortsteile" list={AbholgebietOrtsteilList} options={{filter: props.id}}/>
                </Tab>
                <Tab label="Mengen">
                    <Resource name="abholgebiet-mengen" list={AbholgebietMengeList} options={{filter: props.id}}/>
                </Tab>
                <Tab label="Export">
                    <AbholgebietExportFastEdit actions={<ShowActionsAbholgebietTermineExport/>} {...props} />
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
}

const showStyles = makeStyles({
    tabbedLayout: {
        marginBottom: '1em'
    }
});

const AbholgebietExportFastEdit = (props) => {
    const showClasses = showStyles();

    return (
        <Edit title={" / Export"} className={showClasses.tabbedLayout}  {...props}>
            <Paper elevation={3} sx={{
                p: 2,
                background: '#2872b7',
                color: '#fff',
                textAlign: 'left'
            }}>
                <Typography variant={"h4"}>
                    <TextField source="name"/>
                </Typography>
                <Paper elevation={3} sx={{
                    p: 1,
                    background: '#fff',
                    color: '#000',
                    textAlign: 'left',
                    marginTop: '10px'
                }}>
                    <Typography variant={"h4"}>
                        <TextField source="beschreibung"/>
                    </Typography>
                </Paper>
            </Paper>
        </Edit>
    );
};

export {AbholgebietList, AbholgebietShow};
